import React from 'react';
import i18n from '@/i18n/config';
import { Input } from '@heroui/react';
import { SearchDropdown } from '@/components/table';
import type { BlockedUsersSearchFields } from '@/hooks/blockedUsers';

interface SearchFieldsProps {
  searchFields: BlockedUsersSearchFields;
  setSearchFields: React.Dispatch<React.SetStateAction<BlockedUsersSearchFields>>;
  isSearchOpen: boolean;
  setIsSearchOpen: (open: boolean) => void;
  onApply: () => void;
  onClear: () => void;
}

export function SearchFieldsComponent({
  searchFields,
  setSearchFields,
  isSearchOpen,
  setIsSearchOpen,
  onApply,
  onClear
}: SearchFieldsProps) {
  return (
    <SearchDropdown
      isOpen={isSearchOpen}
      setIsOpen={setIsSearchOpen}
      widthPx={200}
      onApply={onApply}
      onClear={onClear}
    >
      <Input
        label={i18n.t('copy.search_fingerprint_ip')}
        size="sm"
        value={searchFields.search}
        onValueChange={(v) => setSearchFields((s) => ({ ...s, search: v }))}
      />
      <Input
        label={i18n.t('copy.domain_id_1')}
        size="sm"
        type="number"
        placeholder={i18n.t('common.optional')}
        value={searchFields.domain_id}
        onValueChange={(v) => setSearchFields((s) => ({ ...s, domain_id: v }))}
      />
    </SearchDropdown>
  );
}
